import { Flex, Heading, Text, useTheme, Image } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { rem, rgba } from 'polished';
import React, { FC, memo, useEffect, useState } from 'react';
import { mq } from 'styles/breakpoints';
import TextTruncate from 'react-text-truncate';
import useBreakpoint from 'hooks/useBreakpoint';

interface Props {
  text: string;
  image: string;
  title: string;
  truncateToLines?: number;
  imagePadding?: boolean;
}
const Wrapper = styled(Flex)`
  height: 175px;
  width: 100%;
  display: flex !important;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  padding-left: 28px;
  padding-right: 28px;
  padding-bottom: 20px;
  position: relative;
  border-radius: 15px;
  ${mq.xl} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0;
  }
`;

const StyledImage = styled(Image)<{ imagepadding?: boolean }>`
  display: block;
  height: ${(props): string => (props.imagepadding ? '155px' : '175px')};
  width: 100%;
  flex: 1;
  object-fit: contain;

  ${mq.xl} {
    flex: none;
    width: calc(50% - 30px);
  }
`;

const Header = styled(Heading)`
  font-weight: bold;
  font-size: ${rem(19)}!important;
  line-height: 22px;
  text-align: left;

  ${mq.xl} {
    align-self: flex-start;
  }
`;

const Description = styled(Text)`
  font-weight: normal;
  font-size: ${rem(13)};
  line-height: 160%;
  text-align: center;
  z-index: 2;
  margin-top: 25px;
  ${mq.xl} {
    text-align: left;
    align-self: flex-start;
  }
`;

const TextWrapper = styled(Flex)`
  width: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${mq.xl} {
    flex: none;
    margin-top: 0;
    width: calc(50% - 30px);
  }
`;

const Slide: FC<Props> = ({ text, image, title, truncateToLines, imagePadding }) => {
  const { colors } = useTheme();
  const { isDesktop } = useBreakpoint();
  const [showDescription, setShowDescription] = useState(false);

  // this is an ugly hack so that truncate rerenders with text change
  // otherwise it's blank
  useEffect(() => {
    setShowDescription(false);
    setTimeout(() => {
      setShowDescription(true);
    }, 100);
  }, [text]);

  return (
    <Wrapper key={image} border={`1px solid ${rgba(colors.gray[400], 0.3)}`}>
      <StyledImage src={`${image}?q=100&h=255&auto=format`} imagepadding={imagePadding} />
      {isDesktop && (
        <TextWrapper>
          <Header color="gray.900">{title}</Header>
          {showDescription && (
            <Description color="gray.900">
              {truncateToLines ? <TextTruncate line={truncateToLines} text={text} truncateText="..." element="span" /> : text}
            </Description>
          )}
        </TextWrapper>
      )}
    </Wrapper>
  );
};

export default memo(Slide);
